<template>
    <div class="container">
        <div class="common-header-wrap">
            <mt-header title="设置" class="common-header">
                <mt-button slot="left" icon="back" @click="$router.go(-1)"></mt-button>
            </mt-header>
        </div>
        <div class="main-content">
            <div  @click="goSettingInfo">
                <flex-line :is-link="true" :show-border="true"><span class="line-name">店铺管理</span></flex-line>
            </div>
            <div class="pt-10 pb-10">
                <div class="common-btn ds-button-large" @click="logout">退出登录</div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import { Toast } from 'mint-ui'
import { logout } from '../../../api/seller'
import flexLine from '../../flexLine'
export default {
  name: 'Index',
  computed: {
    ...mapState({
      seller: state => state.seller.info
    })
  },
  components: { flexLine },
  methods: {
    ...mapMutations({
      sellerLogout: 'sellerLogout'
    }),
    logout () {
      logout(this.seller.seller_name).then(res => {
        this.sellerLogout()
        this.$router.push({ name: 'HomeSellerLogin' })
      }).catch(function (error) {
        Toast(error.message)
      })
    },
    goSettingInfo () {
      this.$router.push({ name: 'SellerSettingInfo' })
    }

  }
}
</script>

<style scoped lang="scss">
.main-content{background: #fff;padding:0 $pageSpace}
</style>
